import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.43291,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const IdentityCardIcon = createSvgIcon(
  <>
    <path
      d="M1.61194 9.67213C1.61194 6.63248 1.61194 5.11266 2.55624 4.16836C3.50054 3.22406 5.02036 3.22406 8.06001 3.22406H11.284C14.3237 3.22406 15.8435 3.22406 16.7878 4.16836C17.7321 5.11266 17.7321 6.63248 17.7321 9.67213C17.7321 12.7118 17.7321 14.2316 16.7878 15.1759C15.8435 16.1202 14.3237 16.1202 11.284 16.1202H8.06001C5.02036 16.1202 3.50054 16.1202 2.55624 15.1759C1.61194 14.2316 1.61194 12.7118 1.61194 9.67213Z"
      {...strokeProps}
    />
    <path
      d="M8.866 8.06014C8.866 7.16985 8.14428 6.44812 7.25399 6.44812C6.36369 6.44812 5.64197 7.16985 5.64197 8.06014C5.64197 8.95043 6.36369 9.67216 7.25399 9.67216C8.14428 9.67216 8.866 8.95043 8.866 8.06014Z"
      {...strokeProps}
    />
    <path
      d="M10.4781 12.8962C10.4781 11.1156 9.03465 9.67212 7.25407 9.67212C5.47348 9.67212 4.03003 11.1156 4.03003 12.8962"
      {...strokeProps}
    />
    <path d="M12.0901 7.25409H15.3141" {...strokeProps} />
    <path d="M12.0901 9.67212H15.3141" {...strokeProps} />
  </>,
  { displayName: 'IdentityCardIcon', viewBox: '0 0 20 20' }
);
